import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { object } from "prop-types";
import { connect } from "react-redux";

import Headline from "../../atoms/Headline";
import CardImage from "../../atoms/CardImage";
import { staticTexts } from "../../utils/Translate";
import { getSoriesBySlug } from "../../helper/api";

import "./alsoRead.m.css";

const AlsoRead = ({ story, element, publisherAttributes }) => {
  const linkedStoryId = get(element, ["metadata", "linked-story", "id"], "");
  const linkedStorySlug = get(story, ["linked-stories", linkedStoryId, "url"], "");
  const linkedStoryHeadline = get(story, ["linked-stories", linkedStoryId, "headline"], element.text);
  const [isDataFetched, updateDataFetched] = useState(false);
  const [linkedStoryWithMoreData, updatedLinkedStoryWithMoreData] = useState(null);

  const getAlsoReadStoryData = async (storySlug) => {
    const story = await getSoriesBySlug(storySlug);
    updatedLinkedStoryWithMoreData(story);
    updateDataFetched(true);
  };
  useEffect(() => {
    getAlsoReadStoryData(linkedStorySlug);
  }, []);

  if (!isDataFetched) return null;

  return (
    <a
      rel="noopener noreferrer"
      href={linkedStorySlug}
      styleName="also-read"
      className="also-read"
      data-testid="Also-read"
    >
      <Headline
        text={staticTexts(publisherAttributes.lang).alsoRead}
        headlineType={20}
        headerLevel={3}
        className="also-read-text"
      />
      <div styleName="wrapper">
        <Headline
          text={linkedStoryHeadline}
          headlineType={20}
          headerLevel={4}
          styleName={`${publisherAttributes.lang}-headline`}
        />
        <CardImage
          story={linkedStoryWithMoreData}
          aspectRatio={[1, 1]}
          imageType="image1x1"
          showAlternateImage={true}
          widths={[100]}
        />
      </div>
    </a>
  );
};

AlsoRead.propTypes = {
  story: object,
  element: object,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(AlsoRead);
